<template>
  <v-layout class="header-container" align-center>
    <div class="logo">
      <span @click="backToAll">
        <img :src="logoUrl" style="max-height: 40px;" />
      </span>
    </div>
    <span>
      {{ title }}
    </span>
    <v-spacer></v-spacer>
    <v-btn small @click="backToAll" v-if="homeButton">
      <v-icon small class="left-icon">mdi-chevron-left</v-icon>
      Explore All
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "API Documentation"
    },
    logoUrl: {
      type: String,
      default:
        "https://cdn.orb.ee/branding/orbee/corporate/new/primary-logo.png"
    },
    homeButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    backToAll() {
      this.$emit("back-to-all");
    }
  }
};
</script>

<style>
.header-container {
  background-color: #000000;
  color: rgba(255, 255, 255, 0.65);
  cursor: pointer;
}

.logo {
  margin-right: 24px;
}

.left-icon {
  margin-right: 5px;
}
</style>
